module.exports = __webpack_public_path__ + "static/media/textbook.adc27807.jpg";